import { AssetTransactionTypeEnum, type AssetTransactionTypeEnum as AssetTransactionTypeEnumType } from '@talos/kyoko';

/** Omitted from Adjust Market Account Positions — https://talostrading.atlassian.net/browse/PORT-18150?focusedCommentId=439615 */
export const EXCLUDED_ADJUST_POSITION_TYPES = [
  AssetTransactionTypeEnum.SpotTrade,
  AssetTransactionTypeEnum.TradingFee,
  AssetTransactionTypeEnum.UnrealizedPnL,
  AssetTransactionTypeEnum.ReconAdjustment,
  AssetTransactionTypeEnum.Transfer,
  AssetTransactionTypeEnum.TransferFee,
] as const satisfies readonly AssetTransactionTypeEnumType[];

const ASSET_TRANSACTION_TYPE_TEXT_MAPPING: { [key in AssetTransactionTypeEnumType]: string } = {
  [AssetTransactionTypeEnum.Misc]: 'Misc',
  [AssetTransactionTypeEnum.Funding]: 'Funding',
  [AssetTransactionTypeEnum.RealizedPnL]: 'Realized PnL',
  [AssetTransactionTypeEnum.TradingFee]: 'Trading Fee',
  [AssetTransactionTypeEnum.DeliveryFee]: 'Delivery Fee',
  [AssetTransactionTypeEnum.SettlementFee]: 'Settlement Fee',
  [AssetTransactionTypeEnum.Deposit]: 'Deposit',
  [AssetTransactionTypeEnum.Withdrawal]: 'Withdrawal',
  [AssetTransactionTypeEnum.Transfer]: 'Transfer',
  [AssetTransactionTypeEnum.DepositFee]: 'Deposit Fee',
  [AssetTransactionTypeEnum.WithdrawalFee]: 'Withdrawal Fee',
  [AssetTransactionTypeEnum.TransferFee]: 'Transfer Fee',
  [AssetTransactionTypeEnum.SpotTrade]: 'Spot Trade',
  [AssetTransactionTypeEnum.Liquidation]: 'Liquidation',
  [AssetTransactionTypeEnum.LiquidationFee]: 'Liquidation Fee',
  [AssetTransactionTypeEnum.UnrealizedPnL]: 'Unrealized PnL',
  [AssetTransactionTypeEnum.Delivery]: 'Delivery',
  [AssetTransactionTypeEnum.ReconAdjustment]: 'Recon Adjustment',
  [AssetTransactionTypeEnum.StakingReward]: 'Staking Reward',
  [AssetTransactionTypeEnum.StakingRewardFee]: 'Staking Reward Fee',
  [AssetTransactionTypeEnum.Settlement]: 'Settlement',
  [AssetTransactionTypeEnum.PreliminaryCreate]: 'Preliminary Create',
  [AssetTransactionTypeEnum.FinalCreate]: 'Final Create',
  [AssetTransactionTypeEnum.PreliminaryRedeem]: 'Preliminary Redeem',
  [AssetTransactionTypeEnum.FinalRedeem]: 'Final Redeem',
  [AssetTransactionTypeEnum.ManagementFee]: 'Management Fee',
  [AssetTransactionTypeEnum.DepositInterest]: 'Deposit Interest',
};

export function prettifyAssetTransactionTypeEnum(type: AssetTransactionTypeEnumType | string): string {
  return ASSET_TRANSACTION_TYPE_TEXT_MAPPING[type as AssetTransactionTypeEnumType] ?? type;
}
